import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { useTranslation } from 'react-i18next';

/**
 * 全局浏览器返回拦截组件
 * 当用户点击浏览器返回按钮时，弹出确认对话框提示可能会中断当前操作
 */
const BrowserBackInterceptor: React.FC = () => {
    const location = useLocation();
    const { t } = useTranslation('common');

    useEffect(() => {
        // 添加一个空的历史记录状态，用于拦截返回
        const currentState = window.history.state;
        window.history.pushState({ ...currentState, preventBack: true }, '');

        const handlePopState = (_event: PopStateEvent) => {
            // 如果正在显示模态框，不再重复显示
            window.confirm(t('browser_back.confirm'));
        };

        // 监听 popstate 事件（浏览器返回/前进）
        window.addEventListener('popstate', handlePopState);

        return () => {
            window.removeEventListener('popstate', handlePopState);
        };
    }, [location]);

    // 同时处理页面刷新和关闭
    // useEffect(() => {
    //     const handleBeforeUnload = (event: BeforeUnloadEvent) => {
    //         // 检查是否是系统初始化刷新，如果是则跳过确认提示
    //         if (sessionStorage.getItem("skipBeforeUnload") === "true") {
    //             sessionStorage.removeItem("skipBeforeUnload");
    //             return;
    //         }
            
    //         // 现代浏览器会显示标准提示信息
    //         event.preventDefault();
    //         // Chrome 需要设置 returnValue
    //         event.returnValue = '';
    //         window.confirm("Changes you made may not be saved.");
    //     };

    //     window.addEventListener('beforeunload', handleBeforeUnload);

    //     return () => {
    //         window.removeEventListener('beforeunload', handleBeforeUnload);
    //     };
    // }, []);

    return null;
};

export default BrowserBackInterceptor;
